import { render, staticRenderFns } from "./ArrowItem.vue?vue&type=template&id=47f7ec90&scoped=true&"
import script from "./ArrowItem.vue?vue&type=script&lang=js&"
export * from "./ArrowItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f7ec90",
  null
  
)

export default component.exports